/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import { Accordion, AccordionContent, AccordionTitle } from "../ui/Accordion";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/Table";
import Text from "../ui/Text";
import Title from "../ui/Title";

const StyledPersonalDataList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledTable = styled((props) => <Table {...props} />)`
  max-height: 300px;
`;

const ClientPersonalData = ({ data }) => {
  return (
    <StyledPersonalDataList>
      {Object.entries(data).map(([key, value]) => (
        <Accordion key={key}>
          <AccordionTitle>
            <Title size="h3">{`gdpr_${key}`}</Title>
          </AccordionTitle>
          <AccordionContent>
            {Array.isArray(value) && value.length > 0 ? (
              <StyledTable>
                <TableHeader>
                  <TableRow>
                    {Object.keys(value[0]).map((header) => (
                      <TableHead key={header}>{header}</TableHead>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {value.map((item, index) => (
                    <TableRow key={index}>
                      {Object.values(item).map((cellValue, cellIndex) => (
                        <TableCell key={cellIndex}>
                          <Text color="dark">
                            {cellValue !== null && cellValue !== undefined ? cellValue.toString() : ""}
                          </Text>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </StyledTable>
            ) : (
              <Text>Information is missing or has already been deleted</Text>
            )}
          </AccordionContent>
        </Accordion>
      ))}
    </StyledPersonalDataList>
  );
};

export default ClientPersonalData;
